module.exports = __webpack_public_path__ + "a8834aaa95faa7024d9033b82ffd0b55.png";